webpackJsonp([66394752744126],{

/***/ 1252:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ImmunizationStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ACTIVE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"APPROVAL_DECLINED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COMPLETED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DECLINED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DELETED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"ENTERED_IN_ERROR"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"PENDING"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"PENDING_APPROVAL"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"RETURNED"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-immunization-status-486df92df3e41419b89e.js